import { getSupabaseAdmin } from '../components/supabaseClient';

// Table name kept local (deliberately not added to env.js) — one row per
// signed document.
const DOCUMENT_SIGNATURES_TABLE = 'document_signatures';

// All access to document_signatures. Uses the admin client (schema-scoped) —
// same reasoning as useVersionCount/useSignedStatus: RLS restricts this table,
// and the service role is what makes lock state visible to every viewer.

export async function readSignatureRecord(documentPath, schema = null) {
  if (!documentPath) return null;
  try {
    const admin = getSupabaseAdmin();
    // Cross-schema charts live in the PATIENT's schema, not the viewer's; scope
    // the query to the document's schema (same pattern as VersioningSystem).
    const sb = schema ? admin.schema(schema) : admin;
    const { data, error } = await sb
      .from(DOCUMENT_SIGNATURES_TABLE)
      .select('original_path, signed, signer_name, signer_email, signature_text, signed_at, lock_password, is_locked')
      .eq('original_path', documentPath)
      .limit(1);
    if (error) {
      console.warn('[documentSignatures] read failed:', error.message);
      return null;
    }
    return data?.[0] || null;
  } catch (err) {
    console.warn('[documentSignatures] read error:', err.message);
    return null;
  }
}

export async function writeSignatureRecord({ documentPath, signerName, signerEmail, signatureText, password, schema = null }) {
  if (!documentPath) return { ok: false, error: 'missing documentPath' };
  try {
    const admin = getSupabaseAdmin();
    // Write the lock row into the document's schema (cross-schema safe).
    const sb = schema ? admin.schema(schema) : admin;
    const { error } = await sb
      .from(DOCUMENT_SIGNATURES_TABLE)
      .upsert(
        {
          original_path: documentPath,
          signed: true,
          signer_name: signerName || '',
          signer_email: signerEmail || '',
          signature_text: signatureText || '',
          lock_password: password || '',
          is_locked: true,
        },
        { onConflict: 'original_path' },
      );
    if (error) return { ok: false, error: error.message };
    return { ok: true };
  } catch (err) {
    return { ok: false, error: err.message };
  }
}
